import React from 'react';
import { useParams } from 'react-router-dom';
import Plan from '@component/gridgio/project/plan';
import PageTemplate from '@page/gridgio/page-template';
import * as color from '@constant/color';

const PlanPage: React.FC = () => {
  const { projectKey = '' } = useParams();
  return (
    <PageTemplate customHeader='none' title='도면 관리' mode='page' backgroundColor={color.GRAY_BACKGROUND_COLOR}>
      <Plan key={projectKey} />
    </PageTemplate>
  );
};

export default PlanPage;
